import {Directive, Input, OnDestroy, OnInit} from '@angular/core';
import {ExgMapLayerManagerService} from '../services';

let layerId = 0;

/*
 * This directive adds a transit layer to a google map instance
 * <exg-map-transit-layer> <exg-map-transit-layer>
 * */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'exg-map-transit-layer',
})
export class ExgMapTransitLayerDirective implements OnInit, OnDestroy {
  private _addedToManager = false;
  private _id: string = (layerId++).toString();

  constructor(private _manager: ExgMapLayerManagerService) {
  }

  ngOnInit(): void {
    if (this._addedToManager) {
      return;
    }
    this._manager.addTransitLayer(this);
    this._addedToManager = true;
  }

  /** @internal */
  id(): string {
    return this._id;
  }

  /** @internal */
  toString(): string {
    return `ExgMapTransitLayer-${this._id.toString()}`;
  }

  /** @internal */
  ngOnDestroy(): void {
    this._manager.deleteLayer(this);
  }

}
